(function () {
  document.querySelectorAll('.product-spotlight__track-wrapper').forEach(function (wrapper) {
    var track = wrapper.querySelector('.product-spotlight__track, .product-spotlight__track--reverse');
    if (!track) return;

    var isReverse = track.classList.contains('product-spotlight__track--reverse');
    var startX = 0;
    var currentX = 0;
    var offset = 0;
    var dragging = false;
    var resumeTimer = null;

    function getAnimationProgress() {
      var style = window.getComputedStyle(track);
      var matrix = new DOMMatrix(style.transform);
      return matrix.m41;
    }

    function stopAnimation() {
      offset = getAnimationProgress();
      track.style.animation = 'none';
      track.style.transform = 'translateX(' + offset + 'px)';
    }

    function resumeAnimation() {
      var totalWidth = track.scrollWidth / 2;
      var normalizedOffset = offset % totalWidth;
      if (!isReverse && normalizedOffset > 0) normalizedOffset -= totalWidth;
      if (isReverse && normalizedOffset < 0) normalizedOffset += totalWidth;

      var progress = Math.abs(normalizedOffset) / totalWidth;
      var duration = parseFloat(getComputedStyle(track).getPropertyValue('--spotlight-duration')) || 25;
      var remaining = duration * (1 - progress);

      track.style.transform = '';
      track.style.animation = '';

      var animName = isReverse ? 'spotlightScrollReverse' : 'spotlightScroll';
      track.style.animation = animName + ' ' + duration + 's linear infinite';
      track.style.animationDelay = '-' + (duration * progress) + 's';
    }

    track.addEventListener('touchstart', function (e) {
      dragging = true;
      startX = e.touches[0].clientX;
      currentX = startX;
      if (resumeTimer) clearTimeout(resumeTimer);
      stopAnimation();
    }, { passive: true });

    track.addEventListener('touchmove', function (e) {
      if (!dragging) return;
      var x = e.touches[0].clientX;
      var delta = x - currentX;
      currentX = x;
      offset += delta;

      var totalWidth = track.scrollWidth / 2;
      if (!isReverse && offset > 0) offset -= totalWidth;
      if (!isReverse && offset < -totalWidth) offset += totalWidth;
      if (isReverse && offset < -totalWidth) offset += totalWidth;
      if (isReverse && offset > 0) offset -= totalWidth;

      track.style.transform = 'translateX(' + offset + 'px)';
    }, { passive: true });

    track.addEventListener('touchend', function () {
      dragging = false;
      resumeTimer = setTimeout(function () {
        resumeAnimation();
      }, 2000);
    });
  });
})();
